import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { writeWarn } from '../../../common/logger';
import { reportActions } from '../../../../store/reportStore';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import { dataCorrectionPaymentHistorySchema } from '../../validations/dataCorrectionPaymentHistorySchema';
import { repiActions, dataCorrectionSection, dataCorrectionType, repiDomain, repiContractFields, repiProductCategories, repiLimits } from '../../../../store/repiStore';
import HistoryLink from '../../../common/historyLink';
import BbDatePicker from '../../../common/datePicker';
import RepiContractHeader from '../paymentHistory/repiContractHeader';
import RepiDataCorrectionTable from './repiDataCorrectionTable';
import RepiDataCorrectionButtons from './repiDataCorrectionButtons';
import RepiDataCorrectionTableColumn from './repiDataCorrectionTableColumn';

import Cross from '../../../../img/icons/Cross';

import '../../repi.scss';

const DATE_FORMAT = "DD.MM.YYYY";

class RepiDataCorrectionContract extends React.Component {
    state = {
        showHistory: true,
        enableReinitializeStartDate: false,
        enableReinitializeEndDate: false
    };

    render() {
        const { contract, contractIndex, pendingData } = this.props;

        return (
            <div key={contract.contractId}>
                <div className={classnames("repi-contract-container", {
                        last: (contractIndex + 1) % repiLimits.dataCorrectionContracts === 0,
                        first: (contractIndex + 1) % repiLimits.dataCorrectionContracts === 1
                })}>
                    <RepiContractHeader contract={contract}
                        contractIndex={contractIndex + 1}
                        isInternalDataCorrection={this.props.isDataCorrection(true)}
                        isAnyDataCorrection={this.props.isDataCorrection()}
                        isSubject={this.props.isSubject()}
                        isPlus={this.props.isPlus()}
                        headerDataCorrection={this.renderContractHeaderEditor(contract)}
                        domain={this.props.domain}
                    />
                    {this.renderContractPaymentHistory(contract, contractIndex, pendingData)}
                </div>
            </div>
        );
    }

    componentDidMount() {
        const headerData = this.props.contractHeader[this.props.contract.contractId];
        if (isNullOrUndefined(headerData) || isNullOrUndefined(headerData.startDate) || isNullOrUndefined(headerData.endDate)) {
            this.props.updateContractHeaderData(this.props.contract.contractId, {
                startDate: isNullOrUndefined(this.props.contract.startDate) ? null : this.props.contract.startDate,
                startDateInput: isNullOrUndefined(this.props.contract.startDate) ? null : new Date(this.props.contract.startDate),
                startDateChanged: false,
                startDateIsValid: true,
                endDate: isNullOrUndefined(this.props.contract.endDate) ? null : this.props.contract.endDate,
                endDateInput: isNullOrUndefined(this.props.contract.endDate) ? null : new Date(this.props.contract.endDate),
                endDateChanged: false,
                endDateIsValid: true
            })
        }
    }

    renderContractPaymentHistory = (contract, contractIndex, pendingData) => {
        if (isNullOrUndefined(contract) || isNullOrUndefined(contract.payments) || contract.payments.length === 0)
            return null;

        return (
            <div className="repi-contract-history">
                <div className="columns is-gapless is-desktop">
                    <div className="column is-half repi-contract-history-link-wrapper">
                        <HistoryLink isOrange={true} onClick={() => this.setState({ showHistory: !this.state.showHistory })}
                            historyExpanded={this.state.showHistory}
                        />
                    </div>
                    <div className="column">
                        <RepiDataCorrectionButtons small noTopMargin deleteContract
                            onInsert={(e) => this.onButtonClick(e, contractIndex, "insert")}
                            onSave={(e) => this.onButtonClick(e, contractIndex, "save")}
                            onCancel={(e) => this.onButtonClick(e, contractIndex, "cancel")}
                            onDeleteContract={(e) => this.onButtonClick(e, contractIndex, "delete")}
                        />
                    </div>
                </div>
                <Collapse isOpen={this.state.showHistory}>
                    <RepiDataCorrectionTable stretched
                        idKey="contractHistoryId"
                        secondaryIdKey="paymentId"
                        updatedOnKeys={["contractHistoryUpdatedOn", "paymentUpdatedOn"]}
                        sectionId={dataCorrectionSection.contracts}
                        data={contract.payments}
                        pendingData={contract.insertedPayments}
                        subjectId={this.props.subjectId}
                        rowIndex={contractIndex}
                        contractId={contract.contractId}
                        updatedOn={contract.updatedOn}
                        product={contract.productCode}
                        validationSchema={dataCorrectionPaymentHistorySchema(this.props.translate)}
                        pageLimit={repiLimits.dataCorrectionContracts}
                    >
                        <RepiDataCorrectionTableColumn name={repiContractFields.dueDate} type={dataCorrectionType.date}
                            label="Repi.Report.PaymentHistory.DueDate" noMaxDate />
                        <RepiDataCorrectionTableColumn name={repiContractFields.paymentDate} type={dataCorrectionType.date}
                            label="Repi.Report.PaymentHistory.PaymentDate" noMaxDate />
                        <RepiDataCorrectionTableColumn name={repiContractFields.amountTotal} type={dataCorrectionType.float}
                            label="Repi.Report.PaymentHistory.Payment.AmountTotal" />
                        <RepiDataCorrectionTableColumn name={repiContractFields.amountPaid} type={dataCorrectionType.float}
                            label="Repi.Report.PaymentHistory.Payment.AmountPaid" />
                        <RepiDataCorrectionTableColumn name={repiContractFields.amountOpen} type={dataCorrectionType.float}
                            label="Repi.Report.PaymentHistory.Payment.AmountOpen" />
                        <RepiDataCorrectionTableColumn name={repiContractFields.totalAmount} type={dataCorrectionType.float}
                            label={`Repi.Report.PaymentHistory.Contract.TotalAmount.${contract.productCategory}`} />
                        {contract.productCategory !== repiProductCategories.regularPayment &&
                            <RepiDataCorrectionTableColumn name={repiContractFields.remainingAmount} type={dataCorrectionType.float}
                                label={`Repi.Report.PaymentHistory.Contract.RemainingAmount.${contract.productCategory}`} />}
                        <RepiDataCorrectionTableColumn name={repiContractFields.overdueAmount} type={dataCorrectionType.float}
                            label="Repi.Report.PaymentHistory.Contract.OverdueAmount" />
                        <RepiDataCorrectionTableColumn name={repiContractFields.dunningLevel} type={dataCorrectionType.list}
                            label="Repi.Report.PaymentHistory.Status" domainKey={repiDomain.dunningLevels} domainEmpty={0} />
                        <RepiDataCorrectionTableColumn name={repiContractFields.isContractOpen} type={dataCorrectionType.bool}
                            label="Repi.Report.PaymentHistory.Opened" />
                        <RepiDataCorrectionTableColumn name={repiContractFields.dataEndDate} type={dataCorrectionType.date}
                            label="Repi.Report.PaymentHistory.Contract.DataEndDate" />
                    </RepiDataCorrectionTable>
                </Collapse>
            </div>
        );
    }

    renderContractHeaderEditor = (contract) => {
        const headerData = this.props.contractHeader[contract.contractId];
        if (isNullOrUndefined(headerData))
            return null;

        const startDateInput = this.getDateInput(headerData.startDateInput);
        const endDateInput = this.getDateInput(headerData.endDateInput);

        return (
            <>
                <div className="repi-data-table-item">
                    <table width="100%" border="0">
                        <tbody>
                            <tr>
                                <td style={{ verticalAlign: "middle" }}>
                                    <div><Translate id="Repi.Report.PaymentHistory.StartDate" /></div>
                                </td>
                                <td>
                                    <BbDatePicker enableReinitialize={this.state.enableReinitializeStartDate}
                                        id="startDate"
                                        name="startDate"
                                        field="startDate"
                                        afterDateChange={(value, valid) => this.onDateChange("startDate", value, valid)}
                                        value={startDateInput}
                                        style={{ margin: "0 auto", height: "100%" }}
                                        yearsBack={30}
                                        disabled={false}
                                        strict={true}
                                        formDateFormat={[DATE_FORMAT, "D.M.YYYY"]}
                                        afterReinitialize={() => this.setState({ enableReinitializeStartDate: false })}
                                    />
                                </td>
                                <td className="right right repi-uppdate-contract-header-buttons">
                                    {this.renderCancelLinkButton(() => {
                                        this.setState({ enableReinitializeStartDate: true }, () => {
                                            this.props.updateContractHeaderData(contract.contractId, {
                                                startDate: isNullOrUndefined(contract.startDate) ? null : contract.startDate,
                                                startDateInput: this.getDateInput(new Date(contract.startDate)),
                                                startDateChanged: false,
                                                startDateIsValid: true
                                            });
                                        });
                                    })}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="repi-data-table-item">
                    <table width="100%" border="0">
                        <tbody>
                            <tr>
                                <td style={{ verticalAlign: "middle" }}>
                                    <div><Translate id={`Repi.Report.PaymentHistory.EndDate${(contract.isContractOpen ? ".Expected" : "")}`} /></div>
                                </td>
                                <td>
                                    <BbDatePicker enableReinitialize={this.state.enableReinitializeEndDate}
                                        id="endDate"
                                        name="endDate"
                                        field="endDate"
                                        afterDateChange={(value, valid) => this.onDateChange("endDate", value, valid)}
                                        value={endDateInput}
                                        style={{ margin: "0 auto", height: "100%" }}
                                        yearsBack={30}
                                        disabled={false}
                                        noMaxDate={true}
                                        formDateFormat={DATE_FORMAT}
                                        afterReinitialize={() => this.setState({ enableReinitializeEndDate: false })}
                                    />
                                </td>
                                <td className="right repi-uppdate-contract-header-buttons">
                                    {this.renderCancelLinkButton(() => {
                                        this.setState({ enableReinitializeEndDate: true }, () => {
                                            this.props.updateContractHeaderData(contract.contractId, {
                                                endDate: isNullOrUndefined(contract.endDate) ? null : contract.endDate,
                                                endDateInput: this.getDateInput(new Date(contract.endDate)),
                                                endDateChanged: false,
                                                endDateIsValid: true
                                            });
                                        });
                                    })}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </>
        )
    }

    renderCancelLinkButton = (onClick) => {
        if (isNullOrUndefined(onClick))
            return null;

        return (
            <span className="m-right-btn">
                <div className="ml-link color">
                    <div className="ml-link-inner">
                        <a className='link-internal' onClick={onClick}>
                            <Cross className="ml-link-icon" />
                            <Translate id="Repi.Report.DataCorrection.Undo" />
                        </a>
                    </div>
                </div>
            </span>
        )
    }

    onButtonClick = (e, rowId, action) => {
        if (!isNullOrUndefined(e))
            e.stopPropagation();

        const button = document.querySelector(`#btn-${dataCorrectionSection.contracts}-${rowId}-${action}`);
        if (!isNullOrUndefined(button))
            button.click();
        else
            writeWarn(`No button #btn-${dataCorrectionSection.contracts}-${rowId}-${action} in document!`)
    }

    onDateChange = (field, value, isValid) => {
        if (isValid) {
            const valueFormatted = moment(value, ["DD.MM.YYYY", "D.M.YYYY"]).format(DATE_FORMAT)
            this.props.updateContractHeaderData(this.props.contract.contractId, {
                [field]: valueFormatted,
                [`${field}Input`]: value,
                [`${field}Changed`]: true,
                [`${field}IsValid`]: true
            })
        } else {
            this.props.updateContractHeaderData(this.props.contract.contractId, {
                [`${field}Input`]: value,
                [`${field}Changed`]: true,
                [`${field}IsValid`]: false
            })
        }
    }

    getDateInput = (value) => {
        if (value instanceof Date)
            return moment(value).format(DATE_FORMAT)
        return value;
    }
}

export default connect(
    state => ({ ...state.repi.props,
        contractHeader: { ...state.repi.dataCorrection }
    }),
    dispatch => bindActionCreators({ ...repiActions, ...reportActions }, dispatch)
)(withLocalize(withRouter(RepiDataCorrectionContract)));